module.exports = __webpack_public_path__ + "img/dmg.e4f5e143.svg";